import React from "react"
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Collapse from "react-bootstrap/Collapse"
import FlatSection from "../components/FlatSection"
import AboutPic from "../images/about_pic.png"
import programs from "../images/programs.png"
import IdfSkema from "../images/idf_skema.png"
import TeamPic from "../images/our_team_pic.png"
import BoardPic from "../images/board_pic.png"
import DonorPic from "../images/donor_pic.png"
import { useTranslation } from "react-i18next"

export default function About() {
  const { t } = useTranslation()
  return (
    <section className="about-area">
      <div className="about-hero bg-light ">
        <div className="about-hero-img">
          <img src={AboutPic} alt="A technician wearing glass" />
        </div>
        <div className="hero-shape"></div>
        <Container>
          <Row>
            <Col sm={6} className="about-hero-content">
              <h1 className="title-section">
                About
                <br />
                IDF
              </h1>
              <h5 className="description-section mt-30">{t("about")}</h5>
              <p className="text-content">{t("aboutCont")}</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="about-progress-img text-center">
        <Row>
          <Col lg={12}>
            <img src={IdfSkema} alt="Progress"></img>
          </Col>
        </Row>
      </Container>
      <div className="about-vision bg-light" id="mission">
        <Container>
          <Row className="about-vision-title text-center">
            <Col>
              <hr />
            </Col>
            <Col sm={6}>
              <h2 className="title-section-inside">{t("fVisionMision")}</h2>
            </Col>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row className="about-vision-sub text-center">
            <Col lg={12} className="m-auto">
              <p className="description-section">{t("aVision")}</p>
              <p className="description-section">{t("vision")}</p>
              <p className="description-section">{t("aMision")}</p>
              <ol className="description-section">
                <li>{t("mision1")}</li>
                <li>{t("mision2")}</li>
                <li>{t("mision3")}</li>
              </ol>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="about-flat" style={{ marginTop: "-80px" }}>
          <Col>
            <FlatSection />
          </Col>
        </Row>
      </Container>
      <div className="the-people bg-light pt-50 mt-50 pb-80">
        <Container>
          <Row>
            <Col sm={6}>
              <h2 className="title-section-inside">The People</h2>
              <span className="sub-title">Behind Our Organization</span>
            </Col>
          </Row>
          <Row className="the-people-image justify-content-between mt-50 text-center">
            <Col sm={3}>
              <Link to="/the-people">
                <img src={TeamPic} alt="Team"></img>
                <h5 className="sub-title-mobile mt-30">OUR TEAM</h5>
              </Link>
            </Col>
            <Col sm={3}>
              <Link to="/the-people">
                <img src={BoardPic} alt="Directors"></img>
                <h5 className="sub-title-mobile mt-30">BOARD OF DIRECTORS</h5>
              </Link>
            </Col>
            <Col sm={3}>
              <Link to="/the-people">
                <img src={DonorPic} alt="Partners"></img>
                <h5 className="sub-title-mobile mt-30">PARTNERS</h5>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="about-programs bg-white">
        <Container>
          <Row className="about-programs-content">
            <Col sm={6} className="about-programs-img">
              <img src={programs} alt="A busy team" />
            </Col>
            <Col sm={6} className="about-programs-content">
              <h2 className="title-section-inside mt-50">Our Programs</h2>
              <p className="text-content mt-50">"{t("vision")}"</p>
              <div className="about-programs-btn">
                <Link to="/timeline" className="main-btn" role="button">
                  Learn More
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="about-faq bg-light">
        <Container>
          <Row>
            <Col sm={6} className="about-faq-content mt-50 mb-50">
              <h2 className="title-section-inside">FAQ</h2>
              <span className="sub-title">More Informations</span>
            </Col>
          </Row>
          <hr />
          {contents.map((content, i) => (
            <FaqCollapse
              key={i}
              title={content.title}
              message={content.message}
            />
          ))}
        </Container>
      </div>
    </section>
  )
}

const contents = [
  {
    title: "fAQTitle1",
    message: "fAQMessage1",
  },
  {
    title: "fAQTitle2",
    message: "fAQMessage2",
  },
  {
    title: "fAQTitle3",
    message: "fAQMessage3",
  },
  {
    title: "fAQTitle4",
    message: "fAQMessage4",
  },
]

function FaqCollapse(props) {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  return (
    <>
      <div
        className="faq-card d-flex justify-content-between mt-20 mb-10"
        onClick={() => setOpen(!open)}
        aria-controls="faq-collapse-text"
        aria-expanded={open}
        role="button"
        // tabIndex="-1"
        aria-hidden="true"
      >
        <h5 className="faq-collapse-title mb-10">{t(props.title)}</h5>
        {open ? (
          <svg
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            className="bi bi-dash"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        ) : (
          <svg
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            className="bi bi-plus"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"
            />
            <path
              fillRule="evenodd"
              d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"
            />
          </svg>
        )}
      </div>
      <Collapse in={open}>
        <div className="faq-collapse-text text-justify" id="faq-collapse-text">
          <p className="description mb-10" style={{ color: "#646f87" }}>
            {t(props.message)}
          </p>
        </div>
      </Collapse>
      <div
        className="faq-line"
        style={{ borderTop: "1px solid #DADADA" }}
      ></div>
    </>
  )
}
